import { Pipe, PipeTransform } from '@angular/core';
import { FormattingService } from '../services/formatting.service';
import { util } from '../util';

@Pipe({ name: 'format' })
export class FormatPipe implements PipeTransform {
  constructor(
    private formattingService: FormattingService
  ) {
    /**/
  }

  public transform(obj: any, format: string):any {
    if (util.notNullOrUndefinedOrEmpty(obj)) {
      try {
        return this.formattingService[format](obj);
      } catch(e) {
        console.debug('Error formatting pipe', e);
      }
    }
  }
}